module.exports = __webpack_public_path__ + "img/tab2_comment@3x.24f131c1.png";